import className from 'classnames';
import React from 'react';
import { Icon } from '../../../../components';

const EditPointIcon = ({ icon, show, additionalClassNames, handler, disabled }) => {
  return show ?
    <Icon className={className('modify-cpd-hour-icon', additionalClassNames, { disabled })} onClick={
      disabled ? undefined : handler
    } icon={icon} /> :
    null
}

export const AddPointIcon = ({ show, handler, disabled }) => {
  return <EditPointIcon icon='plus-large' disabled={disabled} show={show} handler={handler} additionalClassNames='plus' />
}
export const MinusPointIcon = ({ show, handler, disabled }) => {
  return <EditPointIcon icon='minus-large' disabled={disabled} show={show} handler={handler} additionalClassNames='minus' />
}



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/edit-point-icon.js